import type { SeatMapOptions } from "@checkout/components";
import type { HopperSeatMapOptions } from "@checkout/components/SeatSelection/types";
import nusansTextUrl from "../../../../assets/fonts/NuSansText-Regular.woff2?url";
import { nubankVariables } from "../../../defaultTheme";
import seatMapStyles from "./seatMap.scss?inline";

const colors = nubankVariables;

// Gordian seat map styles
export const styleString = `@font-face { font-family: "NuSansText"; font-style: normal; font-weight: normal; src: local("NuSansText"), url("${nusansTextUrl}") format("woff2");}#gordian-seatmap-dialog { font-family: "NuSansText", sans-serif !important;}.gr-rounded-lg { border-radius: 0;}`;
export const seatMapOptions: SeatMapOptions = {
  modal: false,
  fontFamily: "NuSansText",
  textPrimary: "FF0000", // main text color
  textSecondary: "4B4B4B", // secondary text color
  theme: {
    seats: {
      1: {
        // Standard
        fill: "#BBBBBB",
        stopColor: "#BBBBBB",
        labelColor: colors.black,
      },
      2: {
        // Preferred
        fill: "#A9C9FF",
        stopColor: "#A9C9FF",
        labelColor: colors.black,
      },
      3: {
        // Extra Legroom
        fill: "#7FD99A",
        stopColor: "#7FD99A",
        labelColor: colors.black,
      },
      4: {
        // Exit Row
        fill: "#FFB48C",
        stopColor: "#FFB48C",
        labelColor: colors.black,
      },
      5: {
        // Front Seat
        fill: "#DDB9FF",
        stopColor: "#DDB9FF",
        labelColor: colors.black,
      },
      not_available: {
        fill: "#F3F3F3",
        stopColor: "#F3F3F3",
        borderColor: "#A6A6A6",
      },
      selected_seat: {
        stopColor: colors.black,
        labelColor: colors.white,
      },
    },
  },
};

// Hopper Seat Map styles
export const hopperStyleString = `@font-face { font-family: "NuSansText"; font-style: normal; font-weight: normal; src: local("NuSansText"), url("${nusansTextUrl}") format("woff2");} ${seatMapStyles}`;
export const hopperSeatMapOptions: HopperSeatMapOptions = {
  seats: {
    standard: {
      background: "#0B6072",
      label: colors.white,
    },
    extraLegRoom: {
      background: "#E063B1",
      label: colors.black,
    },
    exitRow: {
      background: "#A4107E",
      label: colors.white,
    },
    preferred: {
      background: "#D6EB6D",
      label: colors.black,
    },
    unavailable: {
      background: "#F3F3F3",
      label: colors.black,
    },
    hovered: {
      background: "#0C7A3A",
      label: colors.white,
    },
    selected: {
      background: "#0C7A3A",
      label: colors.white,
    },
  },
  seatLabel: "label",
};
